import { Component, Input, OnChanges, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import {
  PositionEnum, SdAccordionComponent, SdAccordionGroupComponent, SdBorderWrapperComponent, SdButtonComponent,
  SdConvertedPriceComponent, SdLinkComponent, SdProductCustomerComponent, StatusEnum
} from '@seb/web-design-system/core';

import { SdPaymentModeComponent } from '@seb/web-design-system/payment';
import { SdAddressCardComponent } from '@seb/web-design-system/checkout';

import type { IOrderDetails } from './order-details.interface';
import { OrderTypeOnlineEnum } from './order-type.enum';

@Component({
  selector: 'sd-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdBorderWrapperComponent,
    SdAccordionGroupComponent,
    SdAccordionComponent,
    SdProductCustomerComponent,
    SdButtonComponent,
    SdLinkComponent,
    SdAddressCardComponent,
    SdPaymentModeComponent,
    TranslateModule,
    SdConvertedPriceComponent
  ]
})
export class SdOrderDetailsComponent implements OnChanges {
  @Input()
  titleLevelAccordion = 4;

  @Input()
  order: IOrderDetails;

  @Input()
  isOpened = false;

  @Output()
  openRecommendedPriceModal = new EventEmitter<void>();

  @Output()
  private readonly returnProductClicked = new EventEmitter<void>();

  @Output()
  private readonly downloadInvoiceClicked = new EventEmitter<void>();

  orderTypeEnum = OrderTypeOnlineEnum;
  positionEnum = PositionEnum;
  statusEnum = StatusEnum;
  totalProducts = 0;

  ngOnChanges() {
    if (this.order.shipments) {
      this.totalProducts = 0;
      this.order.shipments.forEach((shipmentStatus) => {
        this.totalProducts += shipmentStatus.products.length;
      });
    }
  }

  onopenRecommendedPriceModal(): void {
    this.openRecommendedPriceModal.emit();
  }

  clickReturnProduct(): void {
    this.returnProductClicked.emit();
  }

  downloadInvoice(): void {
    this.downloadInvoiceClicked.emit();
  }
}
